import { render, staticRenderFns } from "./BankCards.vue?vue&type=template&id=4bdccf8d&"
import script from "./BankCards.vue?vue&type=script&lang=js&"
export * from "./BankCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports